import { render, staticRenderFns } from "./FormTypeCard.vue?vue&type=template&id=07b2d3f8&"
import script from "./FormTypeCard.vue?vue&type=script&lang=js&"
export * from "./FormTypeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports